import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  /** Mobile: sidebar slide-in open */
  readonly isSidebarOpen = signal<boolean>(false);
  /** Desktop: sidebar collapsed to icon-only rail */
  readonly isSidebarCollapsed = signal<boolean>(false);

  toggle(): void { this.isSidebarOpen.update(v => !v); }
  open(): void { this.isSidebarOpen.set(true); }
  close(): void { this.isSidebarOpen.set(false); }

    toggleCollapse(): void { this.isSidebarCollapsed.update(v => !v); }
  /** Hide header + sidebar (fullscreen mode, e.g. story recording) */
  readonly hideHeader = signal<boolean>(false);
  setHideHeader(value: boolean): void { this.hideHeader.set(value); }
}

